module Translate (
    Language,
    lookupTranslation,
    setLanguageString
) where

import Prelude

import Effect (Effect)

-- | Set the language string to lookup future translation keys for.
foreign import setLanguage :: String -> Effect Unit

foreign import lookupTranslation :: String -> String

data Language
    = EN

setLanguageString :: Language -> Effect Unit
setLanguageString lang = setLanguage $ case lang of
    EN -> "en"